export const CREDBLOOM_GREEN = '#7ED957';

export function CredBloomWordmark({ className = '', size = 'md' }) {
  const sizeClass =
    size === 'sm' ? 'text-base' :
    size === 'lg' ? 'text-3xl' :
    'text-lg';

  return (
    <span
      className={`inline-flex items-baseline font-bold tracking-tight ${sizeClass} ${className}`}
      style={{ fontFamily: 'Manrope' }}
      aria-label="CredBloom"
    >
      <span className="text-[#111111] dark:text-white">Cred</span>
      <span style={{ color: CREDBLOOM_GREEN }}>Bloom</span>
    </span>
  );
}

export function CredBloomMark({ className = '', compact = false }) {
  return (
    <div
      className={`${compact ? 'w-8 h-8 rounded-lg text-xs' : 'w-14 h-14 rounded-2xl text-lg'} bg-[#111111] flex items-center justify-center shadow-lg ${className}`}
      aria-label="CredBloom"
    >
      <span className="font-bold text-white" style={{ fontFamily: 'Manrope' }}>C</span>
      <span className="font-bold" style={{ color: CREDBLOOM_GREEN, fontFamily: 'Manrope' }}>B</span>
    </div>
  );
}
